import { FloatingChat } from '@sohanscript/chat/floating-connect';
import { ClientOnly, createFileRoute, Outlet } from '@tanstack/react-router';
import { Hydrate } from '@tanstack/react-start';
import { idle } from '@tanstack/react-start/hydration';
import { Footer } from '#/components/layout/footer.tsx';
import { LanguageSuggestion } from '#/components/layout/language-suggestion.tsx';
import { Navbar } from '#/components/layout/navbar.tsx';
import { NotFoundPage } from '#/components/not-found.tsx';
import { getAppEnv } from '#/lib/utils/app-env.ts';
import '@sohanscript/lib/utils/nav-state';

export const Route = createFileRoute('/_main')({
	component: MainLayout,
	notFoundComponent: NotFoundPage,
});

const noContact = getAppEnv('no-contact');

function MainLayout() {
	return (
		<>
			<ClientOnly fallback={<nav className="h-navbar" />}>
				<Navbar />
			</ClientOnly>
			<ClientOnly>
				<LanguageSuggestion />
			</ClientOnly>
			<div className="children flex min-h-safe-screen flex-col">
				<main
					id="main-content"
					className="flex-1 [view-transition-name:main-content]"
				>
					<Outlet />
				</main>
			</div>
			<Hydrate when={idle()}>
				{noContact ? null : <FloatingChat />}
				<Footer />
			</Hydrate>
		</>
	);
}
